import { Divider } from "antd"
import { ConsultationCalendarEvent } from "./scheduleApi"

type Props = {
  consultation: ConsultationCalendarEvent
}

const formatAddress = (customer: ConsultationCalendarEvent["customer"]) => {
  if (!customer) {
    return null
  }

  const parts: string[] = []

  if (customer.address1) {
    parts.push(customer.address1)
  }
  if (customer.address2) {
    parts.push(customer.address2)
  }

  const cityStateZip = [customer.city, customer.state].filter(Boolean).join(", ")
  if (cityStateZip || customer.zip) {
    parts.push([cityStateZip, customer.zip].filter(Boolean).join(" "))
  }

  return parts
}

const ConsultationPopoverContent = ({ consultation }: Props) => {
  const addressLines = formatAddress(consultation.customer)
  const hasCustomerInfo = consultation.customer?.displayName || (addressLines && addressLines.length > 0)

  return (
    <div style={{ maxWidth: 280 }}>
      <div style={{ fontWeight: 600 }}>Consultation</div>
      {hasCustomerInfo && (
        <>
          <Divider style={{ margin: "12px 0" }} />
          {consultation.customer?.displayName && (
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{consultation.customer.displayName}</div>
          )}
          {addressLines && addressLines.length > 0 && (
            <div style={{ color: "#666", fontSize: 13 }}>
              {addressLines.map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default ConsultationPopoverContent
